import useWindowUnderThreshold from '@/hooks/useWindowUnderThreshold';
import { selectPromotion, bannersAnalyticsFunction, videoBannersAnalyticsFunction } from '@/utils/analytics.js';
import { HomePageBanner } from '@desquared/wave-components-library';
import ProductsAside from '../Aside/ProductsAside';
import { ProductsSideSheetStore } from '@/store/sideSheet';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useIsRtl } from '@/contexts/DirectionContext.jsx';

export default function BannerSection(props) {
  const [index, setIndex] = useState(0);
  const [productsSideSheetOpen, setProductsSideSheetOpen] = useState(false);
  const isMobile = useWindowUnderThreshold(850);
  const isRtl = useIsRtl();
  const openSideSheet = index => {
    setIndex(index);
    ProductsSideSheetStore.open();
  };

  useEffect(() => {
    const productsSideSheetStore$ = ProductsSideSheetStore.subscribe(setProductsSideSheetOpen);
    return () => {
      productsSideSheetStore$.unsubscribe();
    };
  }, []);

  return (
    <>
      <HomePageBanner
        isFixedWidth={props.fixedWidth}
        showPagination={props?.showPagination !== undefined ? props?.showPagination : true}
        refreshTime={10000}
        images={props.images}
        isMobile={isMobile}
        isVideo={props.isVideo}
        type={props.type}
        ImageComponent={Image}
        LinkComponent={Link}
        analyticsFunction={props.isVideo ? videoBannersAnalyticsFunction : bannersAnalyticsFunction}
        onClick={
          props?.products
            ? index => {
                openSideSheet(index);
                selectPromotion({
                  creative_name: props.isVideo
                    ? props.images[index]?.title
                    : props.images[index]?.altText ?? 'homepage_carousel',
                  creative_slot: props.isVideo
                    ? props.images[index]?.title
                    : props.images[index]?.altText ?? 'homepage_carousel',
                  promotion_id: props.isVideo
                    ? props.images[index]?.title
                    : props.images[index]?.altText ?? 'homepage_carousel',
                  promotion_name: props.isVideo
                    ? props.images[index]?.title
                    : props.images[index]?.altText ?? 'homepage_carousel',
                });
              }
            : index => {
                selectPromotion({
                  creative_name: props.isVideo
                    ? props.images[index]?.title
                    : props.images[index]?.altText ?? 'homepage_carousel',
                  creative_slot: props.isVideo
                    ? props.images[index]?.title
                    : props.images[index]?.altText ?? 'homepage_carousel',
                  promotion_id: props.isVideo
                    ? props.images[index]?.title
                    : props.images[index]?.altText ?? 'homepage_carousel',
                  promotion_name: props.isVideo
                    ? props.images[index]?.title
                    : props.images[index]?.altText ?? 'homepage_carousel',
                });
              }
        }
        isRtl={isRtl}
      />
      {props?.products?.[index]?.length > 0 && productsSideSheetOpen && (
        <ProductsAside products={props.products[index]} isMobile={isMobile} title={props.titles[index]} />
      )}
    </>
  );
}
